<script setup lang="ts">
import NavHeader from '../NavHeader.vue';
import DesktopHeader from './DesktopHeader.vue';
import ForBusinessHeader from '../ForBusinessHeader.vue';

const route = useRoute();
const isForBusinessPage = computed(() => route.path.includes('for-business'));
</script>

<template>
  <header :class="['header', { _business: isForBusinessPage }]">
    <template v-if="isForBusinessPage">
      <ForBusinessHeader />
    </template>
    <template v-else>
      <div class="header__inner">
        <DesktopHeader />
        <div class="header__nav-wrapper">
          <NavHeader />
        </div>
      </div>
    </template>
  </header>
</template>

<style lang="less">
.header {
  position: relative;
  padding-top: @size-x3;
  padding-bottom: @size-x5;

  &._business {
    padding-top: @size-x6;
  }

  &:not(._business):after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: @color-alto;
  }

  &__inner {
    .container-d();
    .flex-column(@size-x4);

    .top-header {
      margin-bottom: -8px;
    }
  }

  &__nav-wrapper {
    margin-top: @size-x2;
  }
}
</style>
